<template>
  <div class="screening">
    <h2>Coming soon!</h2>
  </div>
</template>

<script>
export default {
  name: 'Screening'
};
</script>

<style scoped>
.screening {
    padding: 40 60px;
    color: black;
    font-size: 20px;
}
</style>
